import React from "react";
import { Link } from "react-router-dom";
import AccountButton from "./AccountButton";
import ProfileNudge from "./ProfileNudge";
import { ArrowLeft } from "lucide-react";

const LOGO = "/assets/brand/logo.png";

/**
 * Coquille commune des pages de jeu (design yummartinique.com) :
 * fond rouge à rayures, en-tête (logo, titre Fredoka, sous-titre script),
 * barre du haut (retour accueil + « Mon compte »), pied de page.
 * Aucun lien admin — le back-office a son URL secrète séparée.
 */
export default function GameShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen w-full bg-yum-pattern flex flex-col items-center px-4 py-6 relative overflow-hidden text-white">
      <div className="absolute top-3 left-3 z-20">
        <Link to="/" data-testid="back-home" className="flex items-center gap-1 text-ink text-xs font-bold bg-white px-3 py-1.5 rounded-full shadow-[0_3px_0_rgba(0,0,0,0.15)] hover:translate-y-0.5">
          <ArrowLeft size={14} /> Accueil
        </Link>
      </div>
      <div className="absolute top-3 right-3 z-20">
        <AccountButton />
      </div>

      <img src={LOGO} alt="YÜM" className="w-32 sm:w-40 mb-2 drop-shadow-xl mt-5" data-testid="brand-logo" />
      <h1 className="font-display text-white text-center text-3xl sm:text-4xl leading-tight" data-testid="game-title">
        <span className="relative inline-block">
          {title}
          <span className="absolute left-0 -bottom-0.5 h-2.5 w-full bg-sun rounded-full -z-0" />
        </span>
      </h1>
      {subtitle && (
        <p className="font-script text-sun text-2xl sm:text-3xl mb-4 mt-1">{subtitle}</p>
      )}

      {children}

      <p className="text-white/55 text-xs mt-10">YÜM — Le François, Martinique</p>
      {/* Collecte progressive : 1 question de profil (âge, e-mail) par nouvelle partie */}
      <ProfileNudge />
    </div>
  );
}
